import { server_connection } from 'config';
import store from 'store';

export const UPDATE_QUALIFICATION_FORM      = '[QUALIFICATION APP] UPDATE QUALIFICATION FORM';
export const GET_QUALIFICATION_LIST         = '[QUALIFICATION APP] GET QUALIFICATIONs';
export const UPDATE_QUALIFICATION_LOADED    = '[QUALIFICATION APP] UPDATE_QUALIFICATION_LOADED';
export const GET_QUALIFICATION              = '[QUALIFICATION APP] GET QUALIFICATION';
export const GET_QUALIFICATION_EDIT_INFO    = '[QUALIFICATION APP] GET QUALIFICATION EDIT INFO';

export function updateQualificationForm(qualification_data) {
    return {
        type: UPDATE_QUALIFICATION_FORM,
        payload: qualification_data
    }
}

export function updateQualificationLoaded(setting) {
    return {
        type: UPDATE_QUALIFICATION_LOADED,
        payload: setting
    }
}

export function getQualification(qualification_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/qualification/get/' + qualification_id)
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: GET_QUALIFICATION,
                    payload: data,
                });
            });
    }
}

export function getQualificationEditInfo(qualification_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/qualification/get/edit_info/' + qualification_id)
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: GET_QUALIFICATION_EDIT_INFO,
                    payload: data,
                });
            });
    }
}

export function getQualificationData(qualification_id) {
    return (dispatch) => {
        Promise.all([
            dispatch(getQualification(qualification_id)),
            dispatch(getQualificationEditInfo(qualification_id))
        ]).then(
            () => dispatch(updateQualificationLoaded(true))
        )
    }
}

export function getQualificationList() {
    const auth_id = store.getState().auth.user.data.auth_id;
    return (dispatch, getState) => {
        fetch(server_connection + '/qualification/list/' + auth_id)
            .then((response) => response.json())
            .then((qualifications) => {
                dispatch({
                    type: GET_QUALIFICATION_LIST,
                    payload: qualifications,
                });
            });
    }
}

export function deleteQualification(qualification_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/qualification/delete',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ qualification_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getQualificationList());
            });
    }
}


export function saveQualification(qualification, auth_id) {
    const newQual = { ...qualification, CreateAuthID: auth_id, LastEditAuthID: auth_id }
    return async (dispatch, getState) => {
        await fetch(server_connection + '/qualification/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    qualification: newQual
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getQualificationList());
            });
    }
}



// WEBPACK FOOTER //
// src/main/content/qualification/store/actions/qualification.actions.js